import React from "react";
import { Accordion, Col, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaQuestionCircle } from "react-icons/fa";
import styled from "styled-components";
import ReactMarkdown from 'react-markdown';

const FAQSection = () => {
  const { t } = useTranslation();

  return (
    <ContainerDiv>
      <h3>
        {t("auth.registerFaq.title")}
      </h3>
      <Accordion defaultActiveKey="0" className="panel-group panel-ctn">
        {t("auth.registerFaq.questions", { returnObjects: true }).map((item, index) => (
          <Accordion.Item eventKey={index.toString()} key={index}>
            <Accordion.Header>
            {item.question}
            </Accordion.Header>
            <Accordion.Body>
              <ReactMarkdown>{item.answer1}</ReactMarkdown>
              {item.answer2 && <ReactMarkdown>{item.answer2}</ReactMarkdown>}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </ContainerDiv>
  );
};

const ContainerDiv = styled(Container)`
  .accordion-item {
    h2 {
      margin: 0;
    }
    a {
      color: var(--red)
    }
  }
  .accordion-button:not(.collapsed) {
    background-color: var(--bluegrey);
    color: var(--lightblack);
    box-shadow: none;
  }
`;

export default FAQSection;
